import './index.scss';

import '@splidejs/splide/css/core';

import Splide from '@splidejs/splide';

class LocationSlider {
    constructor(root) {
        this.root = root;
        this.navLocked = false;
        this.navUnlockTimer = null;

        const splideThumbnails = this.root.querySelector('.splide--thumbnails');
        if (splideThumbnails) {
            this.splideThumbnails = new Splide(splideThumbnails, {
                type: 'loop',
                focus: 'center',
                arrows: false,
                pagination: false,
                isNavigation: true,
                fixedWidth: 160,
                gap: 18,
                mediaQuery: 'min',
                breakpoints: {
                    768: {
                        fixedWidth: 172,
                        gap: 18,
                    },
                    1280: {
                        fixedWidth: 186,
                        gap: 24,
                    },
                    1920: {
                        fixedWidth: 254,
                        gap: 24,
                    },
                }
            });
        }

        const splideMain = this.root.querySelector('.splide--main');
        if (splideMain) {
            this.splideMain = new Splide(splideMain, {
                type: 'fade',
                rewind: true,
            });
        }

        if (!this.splideMain) {
            return;
        }

        if (this.splideThumbnails) {
            const images = this.root.querySelectorAll('.location-thumbnail .image');
            const thumbs = this.root.querySelectorAll('.location .thumbnail');

            for (let i = 0; i < images.length; i++) {
                images[i].appendChild(thumbs[i]);
            }

            this.splideMain.sync(this.splideThumbnails);
        }

        this.splideMain.mount();

        if (this.splideThumbnails) {
            this.splideThumbnails.mount();
        }

        // Main arrows only (thumbnails use arrows: false).
        this.buttonPrev = splideMain.querySelector('.splide__arrow--prev');
        this.buttonNext = splideMain.querySelector('.splide__arrow--next');

        this.bindArrow(this.buttonPrev);
        this.bindArrow(this.buttonNext);

        this.splideMain.on('moved resized updated refreshed', () => {
            this.clearNavUnlockTimer();
            this.navLocked = false;
        });

        // Splide toggles disabled at ends; blur so focus does not linger on a hidden control.
        this.splideMain.on('arrows:updated', (prev, next) => {
            this.blurIfDisabled(prev);
            this.blurIfDisabled(next);
        });
    }

    bindArrow(button) {
        if (!button) {
            return;
        }

        // Capture phase: gate rapid double click/tap before Splide's own handler.
        button.addEventListener('click', (event) => {
            this.onArrowClick(event);
        }, true);
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onArrowClick(event) {
        if (this.navLocked || this.splideMain.Components.Controller.isBusy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        this.navLocked = true;
        this.clearNavUnlockTimer();
        this.navUnlockTimer = window.setTimeout(() => {
            this.navUnlockTimer = null;
            this.navLocked = false;
        }, 450);
    }

    clearNavUnlockTimer() {
        if (this.navUnlockTimer !== null) {
            window.clearTimeout(this.navUnlockTimer);
            this.navUnlockTimer = null;
        }
    }

    blurIfDisabled(button) {
        if (button && button.disabled && document.activeElement === button) {
            button.blur();
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.b13-locationslider-container').forEach((node) => {
        new LocationSlider(node);
    });
});
